// removed by extract-text-webpack-plugin
module.exports = {"tabview":"Tabview__tabview__3908i","horizontal":"Tabview__horizontal__3TyjX","vertical":"Tabview__vertical__3X6JG","tabContent":"Tabview__tabContent__JPWdt","tabPane":"Tabview__tabPane__2ydsy","visible":"Tabview__visible__3tDpT","tabTitles":"Tabview__tabTitles__1t4VO","title":"Tabview__title__ln_VA","selected":"Tabview__selected__3bgkI","icon":"Tabview__icon__2xlxW"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Tabview/Tabview.scss
// module id = 1917
// module chunks = 0